import * as tslib_1 from "tslib";
import * as React from 'react';
import { inject, observer } from 'mobx-react';
import IconButton from 'material-ui/IconButton';
import BusyIndicator from '../components/BusyIndicator';
import { FontIcon } from 'material-ui';
var styles = {
    wrapper: {
        margin: '15px 20px',
        padding: '0px 10px',
        backgroundColor: '#fff',
        borderRadius: '5px',
        border: '1px solid #e0e0e0',
    },
    container: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
    },
    text: {
        fontSize: '15px',
        textAlign: 'center',
        letterSpacing: '3px',
        cursor: 'pointer',
    }
};
var SprintChooser = /** @class */ (function (_super) {
    tslib_1.__extends(SprintChooser, _super);
    function SprintChooser(props) {
        var _this = _super.call(this, props) || this;
        _this.handleDecrement = function () {
            var userId = _this.props.userStore.userIdForLoading;
            _this.props.taskStore.prevSprint(userId);
        };
        _this.handleIncrement = function () {
            var userId = _this.props.userStore.userIdForLoading;
            _this.props.taskStore.nextSprint(userId);
        };
        _this.handleReset = function () {
            var userId = _this.props.userStore.userIdForLoading;
            _this.props.taskStore.actualSprint(userId);
        };
        return _this;
    }
    SprintChooser.prototype.componentWillMount = function () {
        var userId = this.props.userStore.userIdForLoading;
        this.props.taskStore.actualSprint(userId);
    };
    SprintChooser.prototype.render = function () {
        if (!this.props.projectStore.configuration.isProjectIntervalBased) {
            return null;
        }
        if (!this.props.preferencesStore.sprintChooserVisible.value) {
            return null;
        }
        return (React.createElement("div", { style: styles.wrapper },
            React.createElement(BusyIndicator, { size: 20, active: this.props.taskStore.isBusy },
                React.createElement("div", { style: styles.container },
                    React.createElement(IconButton, { onClick: this.handleDecrement },
                        React.createElement(FontIcon, { className: "material-icons" }, "chevron_left")),
                    React.createElement("div", { style: styles.text, onClick: this.handleReset },
                        React.createElement("span", null, this.props.taskStore.sprintName)),
                    React.createElement(IconButton, { onClick: this.handleIncrement },
                        React.createElement(FontIcon, { className: "material-icons" }, "chevron_right"))))));
    };
    SprintChooser = tslib_1.__decorate([
        inject('projectStore', 'taskStore', 'userStore', 'preferencesStore'),
        observer
    ], SprintChooser);
    return SprintChooser;
}(React.Component));
export { SprintChooser };



//////////////////
// WEBPACK FOOTER
// ./src/layout/SprintChooser.tsx
// module id = 171
// module chunks = 0